///include /assets/js/app/p/sbproduct.js
///include /assets/js/app/p/sbproduct/vps_os.js
"use strict"

class SBManagedVPSProduct extends SBNonTransferProduct {
    static get prefix() {
        return "managed_vps"
    }
    /**
     *
     * @param {?SProduct} [p]
     */
    constructor(p = null) {
        super(p)
        /** @type {GET.Stack.Catalogue.$ns.catalogue.product.code.provisioningInfo.output} */
        this.provisioningInfo = null
        /** @type {GET.Stack.Catalogue.$ns.catalogue.product.code.vpsOSOptions.output} */
        this.vpsOSOptions = null
    }
    get networkPropertyHandlers() {
        return {
            imageDataUrl: () => $.ajax(`/a/catalogue/productImage/${this.code}`),
            cores: () => this.preloadSingle("provisioningInfo").then(
                i => i.CpuCores
            ),
            disc: () => this.preloadSingle("provisioningInfo").then(
                i => i.OsDiskSizeGb * 2 ** 30
            ),
            provisioningInfo: () =>
                $.ajax(`/n/catalogue/product/${this.code}/provisioningInfo`),
            ram: () => this.preloadSingle("provisioningInfo").then(
                i => i.RamMb * 2 ** 20
            ),
            vpsOSOptions:
                () => $.ajax(`/n/catalogue/product/${this.code}/vpsOSOptions`),
        }
    }
    get codePrefix() {
        return "managed_vps"
    }
    get defaultAbstractPaymentType() {
        return "any"
    }

    get operatingSystems() {
        // Managed VPS cannot have a selected OS
        return null;
    }

    get typeRef() {
        return this.codeComponents[0]
    }
}
SBProduct.register([
    SBManagedVPSProduct
])
